import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import BatchModal from './BatchModal';
import {
  listOfContexts as listOfContextsSelector,
  searchContext as searchContextSelector,
  batchFile as batchFileSelector,
  overwriteOptions as overwriteOptionsSelector,
  structures as structuresSelector,
} from './BatchModalSelectors';

import BatchModalReducer from './BatchModalReducer';
import { batchModalReducerKey } from './BatchModalConstants';
import { initialize, search, setCurrentStructureOptions, setOverwriteOptions } from './BatchModalActions';

const mapStateToProps = (state) => ({
  listOfContexts: listOfContextsSelector(state),
  searchContext: searchContextSelector(state),
  batchFile: batchFileSelector(state),
  overwriteOptions: overwriteOptionsSelector(state),
  structures: structuresSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  initialize: () => dispatch(initialize(ownProps.batchFile)),
  search: (context) => dispatch(search(context)),
  setOverwriteOptions: (options) => dispatch(setOverwriteOptions(options)),
  setCurrentStructureOptions: (options) => dispatch(setCurrentStructureOptions(options)),
});

export default compose(withReducer(batchModalReducerKey, BatchModalReducer), connect(mapStateToProps, mapDispatchToProps))(BatchModal);
